import { gql } from '@ppl/utils/graphql.utils';


export const gqlForgotPassword = gql`
  mutation forgotPassword($input: ForgotPasswordInput!) {
    forgotPassword(input: $input) {
      clientMutationId
    }
  }
`;
